// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Squad In Touch — Base layer
   Light element resets + page defaults built on the tokens.
   Kept minimal so it composes cleanly over Bootstrap-era markup.
   ============================================================ */

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

body {
  margin: 0;
  font-family: var(--font-body);
  font-size: var(--text-md);
  line-height: var(--leading-normal);
  color: var(--text-body);
  background: var(--surface-page);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: 'cv05', 'ss01';
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-heading);
  color: var(--text-strong);
  font-weight: var(--weight-bold);
  line-height: var(--leading-tight);
  letter-spacing: var(--tracking-tight);
  margin: 0;
}

a {
  color: var(--text-link);
  text-decoration: none;
}
a:hover { text-decoration: underline; }

/* tabular figures everywhere numbers line up (tables, scores) */
table, .mono, [data-numeric] {
  font-variant-numeric: tabular-nums;
}

:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
  border-radius: var(--radius-sm);
}

::selection {
  background: var(--blue-100);
  color: var(--text-strong);
}

/* thin, unobtrusive scrollbars on scroll regions */
.sit-scroll {
  scrollbar-width: thin;
  scrollbar-color: var(--slate-300) transparent;
}
.sit-scroll::-webkit-scrollbar { width: 10px; height: 10px; }
.sit-scroll::-webkit-scrollbar-thumb {
  background: var(--slate-300);
  border-radius: var(--radius-pill);
  border: 3px solid transparent;
  background-clip: content-box;
}
.sit-scroll::-webkit-scrollbar-thumb:hover { background: var(--slate-400); }

/* eyebrow / section label utility */
.sit-eyebrow {
  font-size: var(--text-2xs);
  font-weight: var(--weight-bold);
  letter-spacing: var(--tracking-caps);
  text-transform: uppercase;
  color: var(--text-subtle);
}
`, "",{"version":3,"sources":["webpack://./src/styles/squad-theme/tokens/base.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,yBAAyB;EACzB,kCAAkC;EAClC,uBAAuB;EACvB,+BAA+B;EAC/B,mCAAmC;EACnC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,+BAA+B;EAC/B,iCAAiC;EACjC,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;AACA,UAAU,0BAA0B,EAAE;;AAEtC,gEAAgE;AAChE;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA,iCAAiC,WAAW,EAAE,YAAY,EAAE;AAC5D;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA,6CAA6C,4BAA4B,EAAE;;AAE3E,oCAAoC;AACpC;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;AAC3B","sourcesContent":["/* ============================================================\n   Squad In Touch — Base layer\n   Light element resets + page defaults built on the tokens.\n   Kept minimal so it composes cleanly over Bootstrap-era markup.\n   ============================================================ */\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-body);\n  font-size: var(--text-md);\n  line-height: var(--leading-normal);\n  color: var(--text-body);\n  background: var(--surface-page);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-feature-settings: 'cv05', 'ss01';\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-heading);\n  color: var(--text-strong);\n  font-weight: var(--weight-bold);\n  line-height: var(--leading-tight);\n  letter-spacing: var(--tracking-tight);\n  margin: 0;\n}\n\na {\n  color: var(--text-link);\n  text-decoration: none;\n}\na:hover { text-decoration: underline; }\n\n/* tabular figures everywhere numbers line up (tables, scores) */\ntable, .mono, [data-numeric] {\n  font-variant-numeric: tabular-nums;\n}\n\n:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n  border-radius: var(--radius-sm);\n}\n\n::selection {\n  background: var(--blue-100);\n  color: var(--text-strong);\n}\n\n/* thin, unobtrusive scrollbars on scroll regions */\n.sit-scroll {\n  scrollbar-width: thin;\n  scrollbar-color: var(--slate-300) transparent;\n}\n.sit-scroll::-webkit-scrollbar { width: 10px; height: 10px; }\n.sit-scroll::-webkit-scrollbar-thumb {\n  background: var(--slate-300);\n  border-radius: var(--radius-pill);\n  border: 3px solid transparent;\n  background-clip: content-box;\n}\n.sit-scroll::-webkit-scrollbar-thumb:hover { background: var(--slate-400); }\n\n/* eyebrow / section label utility */\n.sit-eyebrow {\n  font-size: var(--text-2xs);\n  font-weight: var(--weight-bold);\n  letter-spacing: var(--tracking-caps);\n  text-transform: uppercase;\n  color: var(--text-subtle);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
